import { contains, __ } from 'ramda';
import translate from 'counterpart';

import { strToDate, strToDateMonth } from './commonMapper';
import EventMapper from './eventMapper';
import evolve from './evolve';
import Parser from 'helpers/parser';

const isFemale = contains(__, ['Ж', 'F']);

const workWithMapper = (text, item) => {
    if (item.type === 'Event') {
        return EventMapper.text(text, item);
    } else {
        let result = {};

        result.date = Parser.date.get(item.text);
        result.text = item.text.replace(result.date, '');
        result.dateTo = Parser.date.get(result.text);
        result.text = result.text.replace(result.dateTo, '');

        return {
            ...item,
            ...result,
            name: item.text.substring(0, item.text.indexOf(result.date)),
            date: result.date.replace(/\//g, '.'),
            dateTo: result.dateTo.replace(/\//g, '.'),
        };
    }
};

const PersonMapper = {
    work: (field = {}) => {
        let begin = strToDateMonth(field.beginWork);
        let end = strToDateMonth(field.endWork);
        field.experience = field.stillWorks = '';

        if (begin) {
            field.experience += `${begin} - `;
            if (end) {
                field.experience += end;
            } else {
                field.stillWorks = translate('person.untilNow');
            }
        }

        return field;
    },
    classifier: (field) => {
        return field.replace(/^\//, '');
    },
    phone: ({code = '', number = '', type = '', comment}) => {
        return {
            text: `${code && `(${code})`} ${number} (${type})`,
            href: 'tel:' + Parser.phone.href((code || '') + (number || '')),
            comment
        };
    },
    email: ({email, type}) => {
        return {
            text: `${email} (${type})`,
            href: 'mailto:' + email
        };
    },
    sex: (field) => {
        const notFemale = field ? 'common.male' : field;
        return isFemale(field) ? 'common.female' : notFemale;
    },
    bithday: value => strToDate(value),
    workWith: evolve({
        parts: { text: workWithMapper }
    }),
};

export default PersonMapper;
